import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree,

} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {UserService} from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AuthOnlyGuard implements CanActivate {
    constructor(private authService: AuthService,
                private userService: UserService,
                private router: Router,
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean|UrlTree> | UrlTree {
      const isConsentRoute = state.url.startsWith('/account/consent');

      if (this.userService.userInfo !== null) {
          if (this.userService.userInfo.client_id !== 131 || this.userService.userInfo.agree || isConsentRoute) {
            return true;
          } else {
            return this.router.createUrlTree(['/account/consent']);
          }
        } else {
            return this.userService.getUserInfo().then((userInfo) => {
                if (!!userInfo) {
                   if (userInfo.client_id !== 131 || userInfo.agree || isConsentRoute) {
                     return true;
                   } else {
                     return this.router.createUrlTree(['/account/consent']);
                   }
                }

                this.authService.setRedirectUrl(state.url);
                if (state.url.indexOf('sso=enabled') > -1) {
                    return this.router.createUrlTree(['/login/sso']);
                }
                return this.router.createUrlTree(['/login']);
            });
        }
    }

    getResolvedUrl(route: ActivatedRouteSnapshot): string {
        return route.pathFromRoot
            .map(v => v.url.map(segment => segment.toString()).join('/'))
            .join('/');
    }
}
